import { usePromotion } from "../hooks/usePromotion";

export default function PromoBar() {
  const { active } = usePromotion();
  if (!active) return null;
  return (
    <div
      data-testid="promo-bar"
      className="bg-[#FF008B] px-4 py-3.5 text-center text-base font-semibold text-white sm:text-lg"
    >
      <del className="text-lg font-bold opacity-90 sm:text-xl">399 zł</del>
      <span className="mx-2" aria-hidden="true">
        →
      </span>
      <strong className="text-lg sm:text-xl">249 zł</strong>. Tylko do 20 października, do północy!
    </div>
  );
}
